<template>
  <VueSlickCarousel v-bind="settings" class="box-container">
    <template #prevArrow>
      <button class="custom-arrow-prev">
        <img src="@/assets/img/boxplot/angulo-izquierdo.svg" alt="Anterior">
      </button>
    </template>
    <div class="box-slide">
      <img src="@/assets/img/boxplot/1.svg" alt="1. Conjunto de datos" class="box-img">
      <p>Estos diagramas son un tipo de gráfico que representa cómo se distribuyen los datos de una muestra mediante la posición de un rectángulo llamado “caja” y la longitud de líneas llamadas “bigotes”. Lo primero que se requiere para su elaboración es un conjunto de datos.</p>
    </div>
    <div class="box-slide">
      <img src="@/assets/img/boxplot/2.svg" alt="2. Grupos de datos" class="box-img">
      <p>El conjunto de datos se divide en cuatro grupos que contienen el mismo número de elementos, es decir, cada grupo contiene el 25% de la muestra. A los valores en los que se posicionan las líneas que dividen a la muestra se les llama “cuartiles” (en ocasiones abreviados como Q1, Q2 y Q3).</p>
    </div>
    <div class="box-slide">
      <img src="@/assets/img/boxplot/3.svg" alt="3. Cuartiles" class="box-img">
      <p>El primer y tercer cuartil se representan mediante la posición de los extremos de la caja. El intervalo entre dichos cuartiles se conoce como rango intercuartil (IQR por sus siglas en inglés), en él se localiza el 50% de los valores de los datos. Por otra parte, la línea que divide la caja indica el valor del segundo cuartil (también conocido como mediana).</p>
    </div>
    <div class="box-slide">
      <img src="@/assets/img/boxplot/4.svg" alt="4. Bigotes" class="box-img">
      <p>La longitud de los bigotes muestra que tan alejados están el 50% de los datos restantes. En general se posicionan en los valores máximo y mínimo de los datos.</p>
      <p>Sin embargo, cuando el conjunto tiene valores muy alejados del resto de los datos, la longitud de los bigotes sólo llega a ser  1.5 veces el IQR.</p>
    </div>
    <div class="box-slide">
      <img src="@/assets/img/boxplot/5.svg" alt="5. Valores atípicos" class="box-img">
      <p>Los valores atípicos se representan mediante un punto posicionado en su valor. La definición de un dato atípico depende del contexto de los datos. Sin embargo, una de las convenciones es considerar como atípico a un valor con una distancia mayor a 1.5 veces el rango intercuartil a partir de los extremos de la caja.</p>
    </div>
    <div class="box-slide">
      <img src="@/assets/img/boxplot/6.svg" alt="6. Promedio" class="box-img">
      <p>Por último, el punto dentro de la caja indica el valor promedio del conjunto de datos.</p>
    </div>
    <template #nextArrow>
      <button class="custom-arrow-next">
        <img src="@/assets/img/boxplot/angulo-derecho.svg" alt="Siguiente">
      </button>
    </template>
  </VueSlickCarousel>
</template>

<script>
import VueSlickCarousel from 'vue-slick-carousel';
import 'vue-slick-carousel/dist/vue-slick-carousel.css';

export default {
  name: 'DaiBoxPlotPresentacion',
  components: { 
    VueSlickCarousel
  },
  data() {
    return {
      settings: {
        arrows: true,
        dots: false,
        slidesToShow: 3,
        slidesToScroll: 3,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            }
          }
        ]
      }
    }
  },
};
</script>

<style scoped lang='scss'>
.box-container {
  box-sizing: border-box;
  padding: 0;
  position: relative;
  display: flex;
  font-size: 14px;
  .box-slide {
    padding: $gap*.5 $gap;
    .box-img {
      margin: auto;
    }
    &.box-v-center {
      padding-top: $gap * 5;
    }
  }
  .custom-arrow-prev {
    z-index: 10;
    display: flex;
    align-items: center;
    position: absolute;
    top: 0;
    bottom: 0;
    background: rgba(0,0,0,0);
    left: ($gap * -.5);
    &:hover,
    &:focus {
      background: rgba(0,155,255,.2);
    }
  }
  .custom-arrow-next {
    z-index: 10;
    display: flex;
    align-items: center;
    position: absolute;
    top: 0;
    bottom: 0;
    background: rgba(0,0,0,0);
    right: ($gap * -.5);
    &:hover,
    &:focus {
      background: rgba(0,155,255,.2);
    }
  }
  @media (min-width: map-get($media-queries-since, "md")) {
    padding: 0;
    .box-slide {
      border-right: 1px solid #ccc;
      min-height: 400px;
    }
  }
}

.nivel-linfocitos {
  display: block;
  height: 16px;
  width: 16px;
  margin-right: 8px;
  float: left;
}
.nivel-normal {
  background: #8BCAFD;
}
.nivel-intermedio {
  background: #C5E5FE;
}
.nivel-bajo {
  background: #E7F4FF;
}
</style>
